module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "staff-alerts"
  }, [_c('facebook-create-dialog', {
    attrs: {
      "isVisible": _vm.showFacebookCreateDialog,
      "me": _vm.me
    },
    on: {
      "onFacebookChannelAdded": function () { return _vm.handleChannelAdded('showFacebookCreateDialog'); },
      "onVisibleChanged": function (value) { return _vm.handleDialogVisibilityChanged(value, _vm.handleFacebookVisibilityChange); }
    }
  }), _vm._v(" "), _c('instagram-create-dialog', {
    attrs: {
      "me": _vm.me,
      "isVisible": _vm.showInstagramCreateDialog
    },
    on: {
      "onFacebookChannelAdded": _vm.refetchChannelList,
      "onVisibleChanged": function (value) { return _vm.handleDialogVisibilityChanged(value, _vm.handleInstagramVisibilityChange); }
    }
  }), _vm._v(" "), _c('email-channel-create-dialog', {
    attrs: {
      "me": _vm.me,
      "isVisible": _vm.showEmailCreateDialog
    },
    on: {
      "onEmailChannelAdded": _vm.refetchChannelList,
      "onVisibleChanged": function (value) { return _vm.handleDialogVisibilityChanged(value, _vm.handleEmailDialogVisibilityChange); }
    }
  }), _vm._v(" "), _c('wechat-channel-create-dialog', {
    attrs: {
      "isVisible": _vm.showWechatCreateDialog
    },
    on: {
      "onEmailChannelAdded": _vm.refetchChannelList,
      "onVisibleChanged": function (value) { return _vm.handleDialogVisibilityChanged(value, _vm.handleWechatDialogVisibilityChange); }
    }
  }), _vm._v(" "), (_vm.showWhatsAppWebCreateDialog) ? _c('whatsapp-web-channel-create-dialog', {
    attrs: {
      "isVisible": _vm.showWhatsAppWebCreateDialog,
      "intialData": {
        phoneNumber: _vm.phoneNumber,
        selectedCountry: _vm.selectedCountry
      }
    },
    on: {
      "onWhatsappChannelAdded": function () { return _vm.handleChannelAdded('showWhatsAppWebCreateDialog'); },
      "onVisibleChanged": function (value) { return _vm.handleDialogVisibilityChanged(value, _vm.handleWhatsappWebDialogVisibilityChange); }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f5852d16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/common/StaffAlerts.vue
// module id = 3426
// module chunks = 3